import { Component, EventEmitter, Inject, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ConnectedDirectSyncAccount } from '@vendasta/listing-products';
import { catchError } from 'rxjs/operators';
import { EMPTY, Observable, Subscription } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';
import { ListingSyncService } from '../../listing-sync.service';
import { AGIDTOKEN } from '../../../local-seo';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'local-seo-listing-sidebar-accounts',
  templateUrl: './listing-sidebar-accounts.component.html',
  styleUrl: './listing-sidebar-accounts.component.scss',
  standalone: false,
})
export class ListingSidebarAccountsComponent implements OnInit, OnDestroy {
  @Input() sourceId: number;
  @Input() sourceName: string;
  @Input() listingUrl: string;
  @Input() account: ConnectedDirectSyncAccount;
  @Input() additionalAccounts: ConnectedDirectSyncAccount[];

  @Output() retry = new EventEmitter<void>();

  subscriptions: Subscription[] = [];
  selectedSSID: string;

  readonly defaultIconUrl =
    'https://vstatic-prod.apigateway.co/listing-builder-client/assets/images/default_profile_normal.png';

  constructor(
    @Inject(AGIDTOKEN) private agid$: Observable<string>,
    private listingSyncService: ListingSyncService,
    private snackBar: MatSnackBar,
    protected translate: TranslateService,
  ) {}

  ngOnInit(): void {
    this.selectedSSID = this.account?.connectionId;
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((sub) => sub.unsubscribe());
  }

  setSelectedSocialService(): void {
    this.subscriptions.push(
      this.listingSyncService
        .setSelectedSocialService(this.selectedSSID, this.sourceId)
        .pipe(
          catchError((err: HttpErrorResponse) => {
            console.log(err);
            const message = err.error?.message ? err.error.message : 'Unknown error';
            this.snackBar.open(
              this.translate.instant('LISTING_SYNC.SOURCE_MENU.UPDATE_SERVICE_FAILURE') + `: ${message}`,
              '',
              { politeness: 'assertive', duration: 5000 },
            );
            return EMPTY;
          }),
        )
        .subscribe(() => {
          this.snackBar.open(this.translate.instant('LISTING_SYNC.SOURCE_MENU.UPDATE_SERVICE_SUCCESS'), '', {
            duration: 5000,
          });
          this.listingSyncService.loadSyncData(this.sourceId);
        }),
    );
  }
}
